import { Box, Breadcrumbs, Button, IconButton, Paper, TablePagination, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { MyListApi } from "../../utils/restApi";
import { Link } from "react-router-dom";
import AcceptIcon from '@mui/icons-material/CheckCircle';
import RejectIcon from '@mui/icons-material/Cancel';
import { useDispatch, useSelector } from "react-redux";
import { addNotification } from "../../slices/notificationSlice";

export const ItemUpdates = () => {

    const dispatch = useDispatch();
    const user = useSelector(state => state.login.user);
    const isAdmin = user?.isAdmin;
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [count, setCount] = useState(0);
    const [itemUpdates, setItemUpdates] = useState(null);

    useEffect(() => {
        if (itemUpdates === null) {
            MyListApi.getItemUpdates(page, pageSize)
                .then(data => {
                    setCount(data.count);
                    setItemUpdates(data.items);
                })
                .catch(error => {
                    dispatch(addNotification({
                        message: error.message,
                        type: 'error',
                    }));
                });
        }
    }, [pageSize, itemUpdates]);

    const handleOnPageChange = e => {
    }

    const handleRowsPerPageChange = e => {
        setItemUpdates(null);
        setPageSize(e.target.value);
    }

    if (!isAdmin) return null;

    return (
        <Paper sx={{ p: '20px' }}>
            <Typography variant="h6">Item Updates</Typography>
            {itemUpdates != null ? itemUpdates.map((u, ix) => {
                return (
                    <Box key={ix} sx={{ display: 'flex', flexDirection: 'row', gap: '4px', alignItems: 'center' }}>
                        <IconButton size="small"><AcceptIcon /></IconButton>
                        <IconButton size="small"><RejectIcon /></IconButton>
                        <Breadcrumbs separator="›">
                            <Typography>{u.tagName}</Typography>
                            <Link to={`/items/${u.itemId}`}><Typography key={ix}>{u.itemName}</Typography></Link>
                            <Link to={`/item-update/${u.id}`}><Typography>{u.property}</Typography></Link>
                            <Typography sx={{ textOverflow: 'ellipsis' }}>{u.value}</Typography>
                        </Breadcrumbs>
                    </Box>
                );
            }) : null}
            <TablePagination
                component='div'
                count={count}
                page={page}
                rowsPerPage={pageSize}
                onPageChange={handleOnPageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </Paper>
    );
}